import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Consultancy">
                            <h2>Tekrevol – Your Partner For Business Process Automation Consultancy</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>TekRevol has helped clients prepare their businesses for future challenges as a digital
                            automation solutions company. Pairing an A-class team and emerging technologies, here is
                            what you can achieve with our automation consultancy:</p>
                        <p>Minimize production errors and design better products
                            Boost customer experience and reinvest your portfolio
                            Measure the value added by process changes
                            Empower employees with automatic systems
                            Boost business productivity and revenue
                            Grow from sustainable business models to scalability
                            What is it like to experience 360-degree business process automation?</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;